import { createStore } from 'effector';
import { generalEnv } from '@nx-frontend/shared/env';
import { Org } from '@nx-frontend/shared/types';

export const initialOrgState: Org = {
  globalId: '',
  userId: 0,
  createdAt: 0,
  updatedAt: 0,
  title: '',
  sub: '',
  maxMembers: 0,
  suspended: false,
  domainShorter: false,
  type: '',
  isOtherDescription: false,
  authFormText: '',
  authFormPrivacyLinkEnabled: false,
  authAllowRegistration: false,
  privacyLinkText: '',
  privacyLinkUrl: '',
  orgType: '',
  isShareAdEnabled: false,
};

export const $org = createStore(initialOrgState);

export const $orgDomain = $org.map((org) =>
  org.domain?.length ? org.domain : `${org.sub}.${generalEnv.nimbusDomain}`
);
export const $orgMaxMembers = $org.map((org) => org.maxMembers);
